// extracted by mini-css-extract-plugin
export default {"updatedToday":"VehicleUpdated_updatedToday__9VT4x"};